import type { InitOptions } from "i18next";

import { isDevelopment, isSSR, isStaging, isTest } from "@shared/utils/fullscriptEnv/fullscriptEnv";

export const baseI18nConfig: InitOptions = {
  compatibilityJSON: "v3",
  debug: (isDevelopment() || isStaging()) && !isSSR() && !isTest(),
  defaultNS: "common",
  fallbackNS: "common",
  lng: "en",
  supportedLngs: ["en"],
  fallbackLng: "en",
};
